<div class="login-redirect" role="region" aria-labelledby="loginRedirectTitle">
  <div class="login-redirect__spinner-wrapper">
    <span class="loader"></span>
    <p class="login-redirect__spinner-wrapper__label">{{ 'PAGES.AUTH.PASSWORDLESS_INTERMEDIATE.TITLE' | translate }}</p>
  </div>
</div>
